/**
 * Board API helpers — wraps /api/board/* endpoints.
 *
 * fix64: saveBoardConfig now always sends `slate_order` so the backend can
 * persist Owner drag-to-reorder. Missing/empty arrays are fine (backend
 * defaults to registry order).
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export async function fetchSlates() {
  const res = await fetch(`${BACKEND_URL}/api/board/slates`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error(`Failed to load slates: HTTP ${res.status}`);
  }
  return res.json();
}

export async function fetchBoardConfig() {
  const res = await fetch(`${BACKEND_URL}/api/board/config`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error(`Failed to load config: HTTP ${res.status}`);
  }
  return res.json();
}

export async function saveBoardConfig(config) {
  const body = {
    slate_colors: config.slate_colors || {},
    status_overrides: config.status_overrides || {},
    slate_order: config.slate_order || [],
  };
  const res = await fetch(`${BACKEND_URL}/api/board/config`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(`Failed to save config: HTTP ${res.status}`);
  }
  return res.json();
}
